import { createEmptyFetchable } from 'helpers/loadableHelpers'
import { Reducer } from 'interfaces'
import { CreateCCPhoneAction, ResetCCPhoneVerificationAction } from 'components/features/creditCard/creditCardStore/actions'
import { PhoneVerifyApiResponse } from 'components/features/creditCard/creditCardStore/endpoints'
import { CreditCardAppState } from 'components/features/creditCard/creditCardStore/state'
import { PAGE_CHANGED } from 'actions/globalActions'

const INITIAL_STATE = createEmptyFetchable<PhoneVerifyApiResponse>()
export const createRequestReducer: Reducer<CreditCardAppState['createPhoneRequest']> = (prevState = INITIAL_STATE, action) => {
  switch (action.type) {
    case CreateCCPhoneAction.type: {
      if (action.meta === 'request') {
        const { errorsMap, ...restPrevState } = prevState
        return {
          ...restPrevState,
          isLoading: true,
          errorCode: null,
        }
      }

      if (action.meta === 'fail') {
        return {
          ...prevState,
          isLoading: false,
          errorCode: action.payload.errorCode,
          errorsMap: action.payload.errorsMap,
          'x-ratelimit-reset': action.payload['x-ratelimit-reset'],
        }
      }

      const { 'x-ratelimit-reset': ratelimit, ...restResponse } = action.payload.response

      return {
        ...INITIAL_STATE,
        data: restResponse,
        'x-ratelimit-reset': ratelimit,
      }
    }

    case PAGE_CHANGED: {
      if (`${ action.payload.next }`.indexOf('/credit-card/onboarding/phone') === 0) {
        return prevState
      }

      return {
        ...INITIAL_STATE,
      }
    }

    case ResetCCPhoneVerificationAction.type: {
      const { 'x-ratelimit-reset': ratelimit } = prevState
      return {
        ...INITIAL_STATE,
        'x-ratelimit-reset': ratelimit,
      }
    }
  }
  return prevState

}
